import { Alert, Box, Button, Typography } from "@mui/material"
import { TAcaoExterna, TErroDetalhe } from "../../../types/api/bpm/detalhar-processo"
import React from "react"

export default function TipoAcaoExterna({
    listaError,
    isLoading,
    actions,
    onAction,
    usuarioPodeRealizar
}: TipoAcaoExternaProps) {

    if (!listaError) return <React.Fragment />

    return (
        <>
            <Alert
                severity="error"
                icon={false}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={1}
                >
                    {listaError.map((item, index) => {
                        const contagemIndex = index + 1
                        return (
                            <Typography variant="body2"><b>{contagemIndex})</b> {item.descricao}</Typography>
                        )
                    })}
                </Box>
            </Alert>

            {
                (typeof actions !== "string" && usuarioPodeRealizar) &&
                <Box
                    mt={2}
                    gap={2}
                    display="flex"
                    alignItems="center"
                >
                    <Button
                        variant="contained"
                        disabled={!actions.comportamento_erro.permitir_reprocessar || isLoading}
                        onClick={() => onAction(false)}
                    >
                        {actions.comportamento_erro.permitir_reprocessar_label}
                    </Button>
                    <Button
                        variant="outlined"
                        disabled={!actions.comportamento_erro.permitir_avancar || isLoading}
                        onClick={() => onAction(true)}
                    >
                        {actions.comportamento_erro.permitir_avancar_label}
                    </Button>
                </Box>
            }
        </>
    )
}

interface TipoAcaoExternaProps {
    listaError: Array<TErroDetalhe> | null
    isLoading: boolean,
    actions: TAcaoExterna | string,
    onAction: (arg: boolean) => void
    usuarioPodeRealizar: boolean
}